//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Trajectory from "./components/OrderWorkTrajectory";
export default {
  components: {
    Trajectory,
  },
  data() {
    return {
      id: "",
      employeeId: "",
      machineIdentity: "",
      employeeDetail: "",
      machineDetail: "",
      workInfo: [],
      imei: "",
      workStartTime: "",
      workEndTime: "",
      iotType: "",
    };
  },
  mounted() {
    let { id, employeeId, machineIdentity, imei, workTime, iotType } =
      this.$route.query;
    this.id = id;
    this.employeeId = employeeId;
    this.machineIdentity = machineIdentity;
    this.imei = imei;
    this.workStartTime = workTime;
    this.workEndTime = workTime;
    this.iotType = iotType;
    this.getEmployeeDetail();
    this.getMachineDetailByMachineIdentity();
    this.getXScanCodeWorkById();
  },
  methods: {
    /**
     * @descripttion: 获取机手信息
     * @Author: juanjuanhui
     * @Date: 2021-11-25 10:45:30
     */
    getEmployeeDetail() {
      this.$http.personnel
        .getEmployeeDetail({ employeeId: this.employeeId })
        .then((res) => {
          this.employeeDetail = res.data;
        });
    },
    /**
     * @descripttion: 获取机具信息
     * @Author: juanjuanhui
     * @Date: 2022-04-22 09:24:33
     */
    getMachineDetailByMachineIdentity() {
      this.$http.work
        .getMachineDetailByMachineIdentity({
          machineIdentity: this.machineIdentity,
        })
        .then((res) => {
          this.machineDetail = res.data;
          this.imei = res.data.imei;
        });
    },
    /**
     * @descripttion: 获取农机作业信息
     * @Author: juanjuanhui
     * @Date: 2022-04-22 09:41:48
     */
    getXScanCodeWorkById() {
      this.$http.work.getXScanCodeWorkById({ id: this.id }).then((res) => {
        this.workInfo = [res.data];
        let { workDate } = res.data;
        this.workStartTime = workDate;
        this.workEndTime = workDate;
      });
    },
  },
};
